var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.5H3C2.59 22.5 2.25 22.16 2.25 21.75C2.25 21.34 2.59 21 3 21H21C21.41 21 21.75 21.34 21.75 21.75C21.75 22.16 21.41 22.5 21 22.5Z",
    fill: "#036185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 3.97967C17.08 2.03967 15.18 1.98967 13.19 3.97967L11.98 5.18967C11.88 5.28967 11.84 5.44967 11.88 5.58967C12.64 8.23967 14.76 10.3597 17.41 11.1197C17.45 11.1297 17.49 11.1397 17.53 11.1397C17.64 11.1397 17.74 11.0997 17.82 11.0197L19.02 9.80967C20.01 8.82967 20.49 7.87967 20.49 6.91967C20.5 5.92967 20.02 4.96967 19.02 3.97967Z",
    fill: "#036185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.61 12.0298C15.32 11.8898 15.04 11.7498 14.77 11.5898C14.55 11.4598 14.34 11.3198 14.13 11.1698C13.96 11.0598 13.76 10.8998 13.57 10.7398C13.55 10.7298 13.48 10.6698 13.4 10.5898C13.07 10.3098 12.7 9.9498 12.37 9.5498C12.34 9.5298 12.29 9.4598 12.22 9.3698C12.12 9.2498 11.95 9.0498 11.8 8.8198C11.68 8.6698 11.54 8.4498 11.41 8.2298C11.25 7.9598 11.11 7.6898 10.97 7.4098C10.9488 7.36441 10.9283 7.31924 10.9084 7.27434C10.7608 6.94102 10.3262 6.84358 10.0684 7.10133L4.33995 12.8298C4.20995 12.9598 4.08995 13.2098 4.05995 13.3798L3.51995 17.2098C3.41995 17.8898 3.60995 18.5298 4.02995 18.9598C4.38995 19.3098 4.88995 19.4998 5.42995 19.4998C5.54995 19.4998 5.66995 19.4898 5.78995 19.4698L9.62995 18.9298C9.80995 18.8998 10.06 18.7798 10.18 18.6498L15.9013 12.9285C16.1608 12.6689 16.0629 12.2235 15.7253 12.0794C15.6873 12.0632 15.6489 12.0467 15.61 12.0298Z",
    fill: "#036185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.32e855239a7c64e73c2cccc9f20d0765.svg";
export { ForwardRef as ReactComponent };